import React, { useCallback, useState } from 'react';
import { Avatar, Image, Table, Tooltip, Typography } from 'antd';

import { OfficialStore } from '@models/OfficialStore';

import './styles.css';
import { useBrand } from '@hooks/BrandContext';
import { FullScreenModal } from '@styles/globals';
import { TeamOutlined } from '@ant-design/icons';
import { useOfficialStoreSeller } from '@hooks/OfficialStoreSellerContext';
import BrandSellersTable from '../BrandSellersTable';
import SellerForm from '../SellerForm';

const { Text } = Typography;

interface OfficialStoreSellerContentProps {
  officialStore: OfficialStore;
}

const OfficialStoreSellerContent: React.FC<OfficialStoreSellerContentProps> = ({ officialStore }) => {
  const { brands } = useBrand();
  const [sellerModalIsVisible, setSellerModalIsVisible] = useState<boolean>(false);
  const [currentBrand, setCurrentBrand] = useState<number>();
  const [expandedRowKeys, setExpandedRowKeys] = useState<any[]>([]);

  const { loadOfficialStoreBrandSellers } = useOfficialStoreSeller();

  const handleCloseSellerModal = useCallback(() => {
    setSellerModalIsVisible(false);
  }, [setSellerModalIsVisible]);

  const handleShowSellerModal = useCallback(
    (brand: any) => {
      setCurrentBrand(brand.brandId);
      setSellerModalIsVisible(true);
    },
    [setSellerModalIsVisible, setCurrentBrand],
  );

  const getBrandLogo = (photoUrl: string, brandName: string) => {
    if (photoUrl)
      return (
        <Image
          src={photoUrl}
          width={30}
          style={{ borderRadius: '12px' }}
          preview={false}
          fallback="data:image/png;base64,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"
        />
      );

    return <Avatar style={{ backgroundColor: 'var(--primary-color)', verticalAlign: 'middle' }}>{brandName[0]}</Avatar>;
  };

  const onTableRowExpand = (expanded: any, record: any) => {
    const keys = [];

    if (expanded) {
      keys.push(record.brandId);
    }

    setExpandedRowKeys(keys);
    loadOfficialStoreBrandSellers(officialStore.officialStoreId, record.brandId);
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'brandId',
      render: (id: string) => <Text>#{id}</Text>,
      width: '100px',
      align: 'center' as 'center',
      sorter: (brandA: any, brandB: any) => brandA.brandId - brandB.brandId,
    },
    {
      title: 'Marca',
      render: (record: any) => (
        <div>
          {getBrandLogo(record.brandPhotoUrl, record.brandName)}
          <Text className="ml-3">{record.brandName}</Text>
        </div>
      ),
      sorter: (brandA: any, brandB: any) => brandA.brandName.trim().localeCompare(brandB.brandName.trim()),
    },
    {
      align: 'right' as 'right',
      title: 'Gerenciar Vendedores',
      render: (record: any) => (
        <Tooltip title="Vincular/Desvincular Vendedores" color="#510c76" key="tooltip" placement="topRight">
          <TeamOutlined
            style={{ cursor: 'pointer', fontSize: '20px', fontWeight: 'bolder', color: 'var(--primary-color)' }}
            onClick={() => handleShowSellerModal(record)}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <Table
        className="mt-4 table-sellers"
        columns={columns}
        dataSource={brands}
        rowKey={(record) => record.brandId}
        pagination={{ pageSize: 8 }}
        expandable={{
          expandedRowRender: (record) => <BrandSellersTable brandId={record.brandId} />,
          onExpand: onTableRowExpand,
        }}
        expandedRowKeys={expandedRowKeys}
        scroll={{ x: 800 }}
      />

      <FullScreenModal
        destroyOnClose={true}
        footer={null}
        forceRender={false}
        visible={sellerModalIsVisible}
        onOk={handleCloseSellerModal}
        onCancel={handleCloseSellerModal}
        bodyStyle={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <SellerForm brandId={currentBrand} />
      </FullScreenModal>
    </>
  );
};

export default OfficialStoreSellerContent;
